module.exports = __webpack_public_path__ + "img/goal-05.3d39207e.png";